var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDollarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14Z",
    fill: "#641C1A",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2546_262887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9987 17.332C15.1033 17.332 15.9987 16.5858 15.9987 15.6654C15.9987 14.7449 15.1033 13.9987 13.9987 13.9987C12.8941 13.9987 11.9987 13.2525 11.9987 12.332C11.9987 11.4116 12.8941 10.6654 13.9987 10.6654M13.9987 17.332C12.8941 17.332 11.9987 16.5858 11.9987 15.6654M13.9987 17.332V17.9987M13.9987 9.9987V10.6654M13.9987 10.6654C15.1033 10.6654 15.9987 11.4116 15.9987 12.332M20.6654 13.9987C20.6654 17.6806 17.6806 20.6654 13.9987 20.6654C10.3168 20.6654 7.33203 17.6806 7.33203 13.9987C7.33203 10.3168 10.3168 7.33203 13.9987 7.33203C17.6806 7.33203 20.6654 10.3168 20.6654 13.9987Z",
    stroke: "#641C1A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2546_262887"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon);
export default __webpack_public_path__ + "static/media/dollar-icon.d1b6d0a4e39c985de09e1c7e5f164a34.svg";
export { ForwardRef as ReactComponent };